import axios from '@/lib/AxApi';

export default {
  getEmployees(params, cb)
  {
    params.onlyActive = 1;
    axios.get('/rest/User/selectRow',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  selectMyData(params, cb)
  {
    axios.get('/rest/User/selectMyData',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  saveEmployee(params, cb)
  {
    if(typeof params.id != 'undefined' && params.id != '')
    {
      axios.post('/rest/User/updateRow', params)
      .then(response => {
        cb(response.data);
      })
      .catch(e => {
        //TODO
      })
    }
    else
    {
      axios.post('/rest/User/insertRow', params)
      .then(response => {
        cb(response.data);
      })
      .catch(e => {
        //TODO
      })
    }
  },
  deleteEmployee(params, cb)
  {
    axios.post('/rest/User/deactivateUser', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/employees.js